var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"reset-btn action-panel__btn action-panel__btn--submit",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.$t('common.reset')))])
}
var staticRenderFns = []

export { render, staticRenderFns }